export const TagAttributes = {
	individualsupport: {
		name: 'Individual Support',
		color: '#006e90',
		tooltip: 'You will receive the background information of the people you will directly support through this program.',
	},
	extremeneed: {
		color: '#DB504A',
		name: 'Extreme Need',
	},
	underfunded: {
		color: '#F7BA2C',
		name: 'Under Funded',
	},
	remotevillages: {
		color: '#8A7090',
		name: 'Remote Villages',
	},
	almostfunded: {
		color: '#80475E',
		name: 'Almost Funded',
		tooltip: 'This program needs less than five donors to be fully funded.',
	},
	onesame: {
		color: '#f18f01',
		name: 'One Same',
		tooltip: 'You will be assigned a beneficiary who benefits from your monthly donation. You will receive regular updates about the progress of your beneficiary',
		image: '/static/images/one-same.svg',
	},
	onedifferent: {
		color: '#43aa8b',
		name: 'One Different',
		tooltip: 'Your donation will help a different beneficiary every month.You will receive regular updates about whom your donation is helping.',
		image: '/static/images/one-different.svg',
	},
	communitysupport: {
		name: 'Community Support',
		color: '#006e90',
		tooltip: 'Donations to this program will fulfill the basic needs of poor communities. You will receive regular updates about the positive change your donation creates.'
	}
};

export const getTagAttributes = type => TagAttributes[type];
